import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'library/util/core-router';
import { resolve } from 'library/helpers/path-resolver';
import Password from 'library/components/form-elements/password';

class PersonalInformation extends React.Component {
    static contextTypes = {
        user: PropTypes.object
    }

    renderPassword = () => {
        const { data, handleChange } = this.props;
        const { user } = this.context;
        if (!!user) {
            return null;
        }

        return [
            <label key={'password'}>
                Password
                <Password name="password" placeholder="Password" onChange={handleChange} value={resolve(data, 'password', '')} disabled={!!user} required={true}/>
            </label>,
            <label key={'password_again'}>
                Confirm Password
                <Password name="password_again" placeholder="Confirm Password" onChange={handleChange} value={resolve(data, 'password_again', '')} disabled={!!user} required={true}/>
            </label>
        ]
    }

    render() {
        const { data, handleChange } = this.props;
        const { user } = this.context;

        let _data = !!user ? user : data;

        const fieldsClass = [
            "resume-builder-fields",
            !!user ? 'resume-builder-fields-disabled' : null
        ].filter(c=>c).join(' ')

        return (
            <section className={!!user ? 'resume-builder-section-disabled' : ''}>
                <h1>{trans`Personal Information`}</h1>
                <div className={fieldsClass}>
                    <div className="resume-builder-fields-disabled-overlay">
                        <div className="resume-builder-fields-disabled-overlay-inner">
                            This information was autofilled from you profile.
                            <small>To edit this information please go to <Link to="/settings">settings</Link></small>
                        </div>
                    </div>
                    <label>
                        {trans`First Name`}
                        <input type="text" name="first_name" placeholder={trans`First Name`} onChange={handleChange} value={resolve(_data, 'first_name', '')} disabled={!!user} required={true}/>
                    </label>
                    <label>
                        {trans`Last Name`}
                        <input type="text" name="last_name" placeholder={trans`Last Name`} onChange={handleChange} value={resolve(_data, 'last_name', '')} disabled={!!user} required={true}/>
                    </label>
                    <label>
                        {trans`Email`}
                        <input type="text" name="email" placeholder={trans`Email`} onChange={handleChange} value={resolve(_data, 'email', '')} disabled={!!user} required={true}/>
                    </label>
                    <label>
                        {trans`Gender`}
                        <select onChange={handleChange} name="gender" value={resolve(_data, 'gender', '')} disabled={!!user} required={true}>
                            <option value="">--Select One--</option>
                            <option value="male">{trans`Male`}</option>
                            <option value="female">{trans`Female`}</option>
                            <option value="other">{trans`Other`}</option>
                        </select>
                    </label>
                    { this.renderPassword() }
                    <label>
                        {trans`Preferred Language`}
                        <select onChange={handleChange} value={resolve(_data, 'preferred_language', '')} disabled={!!user} name="preferred_language">
                            <option value="english">{trans`english`}</option>
                            <option value="simplified-english">{trans`simplified english`}</option>
                            <option value="spanish">{trans`spanish`}</option>
                            <option value="chinese">{trans`chinese`}</option>
                            <option value="thai">{trans`thai`}</option>
                            <option value="russian">{trans`russian`}</option>
                        </select>
                    </label>
                </div>
            </section>
        )
    }
}

export default PersonalInformation;
